import { defineStore } from "pinia";

const SIDEBAR_COLLAPSED_KEY = "gtr-sidebar-collapsed";

function readPersistedSidebarCollapsed(): boolean {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "1";
  } catch {
    return false;
  }
}

interface UiPreferencesState {
  sidebarCollapsed: boolean;
}

export const useUiPreferencesStore = defineStore("uiPreferences", {
  state: (): UiPreferencesState => ({
    sidebarCollapsed: readPersistedSidebarCollapsed(),
  }),

  actions: {
    toggleSidebarCollapsed() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      try {
        localStorage.setItem(
          SIDEBAR_COLLAPSED_KEY,
          this.sidebarCollapsed ? "1" : "0"
        );
      } catch {
        // localStorage no disponible (modo privado, cuotas, etc.) - no persiste entre sesiones, no rompe la app
      }
    },
  },
});
